import { render, staticRenderFns } from "./weiboPlan.vue?vue&type=template&id=1d96dad4&scoped=true"
import script from "./weiboPlan.vue?vue&type=script&lang=js"
export * from "./weiboPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96dad4",
  null
  
)

export default component.exports